// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","btn_manage":"upa5vO","ly_manage":"_7nyoSU","AniFadeIn":"xqtcP1","AniFadeOut":"WvorSK","AniRotate":"TgvGqU","AniPlaceholderFadeOut":"oPHK4B"};